export default "__VITE_ASSET__c2074f81__"